import React from "react";
import { string } from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import { isAuthenticated, isAuthorized } from "../reducers";
import { LOGIN_PATH } from "../constants/global";
import Forbidden from "../pages/403";

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, component: Component, userRole, ...rest }) {
  const authenticated = useSelector(isAuthenticated);
  const authorized = useSelector(isAuthorized(userRole));
  const {
    location: { state = { disableAutoRedirect: false } },
  } = rest;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (authenticated) {
          if (authorized) {
            return Component ? <Component {...props} /> : children;
          } else {
            return <Forbidden from={props.location} />;
          }
        }

        const from = state && state.disableAutoRedirect ? "/" : props.location;
        return (
          <Redirect
            to={{
              pathname: LOGIN_PATH,
              state: { from },
            }}
          />
        );
      }}
    />
  );
}

PrivateRoute.propTypes = {
  userRole: string,
};

export default PrivateRoute;
